import {
  Table,
  TableCell,
  TableContainer,
  TableHeader,
} from "@windmill/react-ui";

import TableLoading from "components/preloader/TableLoading";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import Somethingwentwrong from "pages/Somethingwentwrong";

import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useEffect } from "react";
import NotificationServices from "services/NotificationServices";
import PartialPaymentDrawer from "components/drawer/PartialPaymentDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";

import sidebar from "routes/sidebar";
import NotificationTable from "components/notification/NotificationTable";

const Notification = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { data, loading } = useAsync(NotificationServices.getAllNotification);

  const { title, serviceId } = useToggleDrawer();
  const [itemsPerPage,setItemsPerPage] = useState(10);
  const [tab] = useState(0);
  const [partialpaymentData, setPartialPaymentData] = useState([]);
  const [status, SetStatuss] = useState(false);
  const {
    dataTable,
    serviceData,

    currentPage,
  } = useFilter(partialpaymentData, itemsPerPage);
      useEffect(() => {
    if (dataTable.length !== 0) {
      setItemsPerPage(dataTable.length);
    }
  }, [dataTable]);

  useEffect(() => {
    if (data) {
      const responseData = data?.data || [];

      if (Array.isArray(responseData)) {
        setPartialPaymentData(responseData);
        SetStatuss(data?.status);
      } else if (responseData && typeof responseData === "object") {
        setPartialPaymentData(responseData);
      } else {
        console.error("Expected an array or an object but got:", responseData);
      }
    } else {
      console.error("Data is null or undefined");
    }
  }, [data]);

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "partial payment" && perm.view === 1
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "partial payment" && perm.edit === 1
      );

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          <MainDrawer>
            <PartialPaymentDrawer id={serviceId} />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />
          {loading ? (
            <TableLoading row={12} col={6} width={190} height={20} />
          ) : serviceData?.length !== 0 ? (
            <TableContainer
              className="overflow-y-scroll"
              style={{ maxHeight: "85vh", scrollbarWidth: "thin" }}
            >
              <Table>
                <TableHeader className="custom-table-header capitalize text-center sticky top-0 z-10 text-sm">
                  <tr>
                    <TableCell>Sl.No.</TableCell>
                    <TableCell>Notification</TableCell>

                    <TableCell>Actions</TableCell>
                  </tr>
                </TableHeader>
                <NotificationTable
                  partialpayment={dataTable}
                  perpage={itemsPerPage}
                  currentPage={currentPage}
                  tab={tab}
                  hideEdit={hideEdit}
                />
              </Table>
            </TableContainer>
          ) : (
            <>
              {status !== true ? (
                <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
              ) : (
                <NotFound title="There are no Notifications." />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Notification;
